<template>
  <span>
    <v-icon class="mr-2" color="primary" @click.stop="dialogClicked()"
      >edit</v-icon
    >

    <!-- RENAME COLLECTION FORM DIALOG -->
    <v-dialog v-model="dialog" width="500">
      <v-card class="rounded-lg">
        <v-card-title color="white" primary-title>
          <v-icon color="primary">edit</v-icon>
          <span class="primary--text text--darken-3 title pl-2"
            >Rename Study Dataset</span
          >
        </v-card-title>

        <v-card-text class="primary primary--text text--lighten-5 pt-4">
          <v-form
            ref="form"
            v-model="valid"
            class="white"
            @submit.prevent="onRenameCollection"
          >
            <v-text-field
              ref="vtf"
              v-model="collectionName"
              :rules="[
                () => !!collectionName || 'Study dataset name is required.',
                () =>
                  !collectionNames.includes(collectionName) ||
                  collectionName == oldCollectionName ||
                  'A study dataset with that name already exists.',
              ]"
              prepend-inner-icon="table_chart"
              label="Please name your study dataset."
              filled
              text
              background-color="grey lighten-4"
              class="mt-2"
            >
            </v-text-field>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialog = false">
            <v-icon left>close</v-icon> Cancel
          </v-btn>
          <v-btn
            :loading="loading"
            color="primary"
            :disabled="collectionName == oldCollectionName"
            @click="onRenameCollection"
          >
            <v-icon left>edit</v-icon> Rename Study Dataset</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapActions } from 'vuex';
import { actions } from '@/store/modules/datasetManager/types';

export default {
  props: {
    collection: {
      type: Object,
      required: true,
    },
    collections: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    collectionName: '',
    oldCollectionName: '',
    valid: true,
    dialog: false,
    loading: false,
  }),
  computed: {
    collectionNames() {
      return this.collections.map(c => c.label);
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.showing();
      }
    },
  },
  methods: {
    ...mapActions('datasetManager', {
      renameCollection: actions.RENAME_COLLECTION,
    }),
    showing() {
      setTimeout(() => {
        this.$refs.vtf.focus();
      });
    },
    dialogClicked() {
      this.dialog = !this.dialog;
      if (this.dialog) {
        this.collectionName = this.collection.label;
        this.oldCollectionName = this.collectionName;
      }
    },
    async onRenameCollection() {
      let collectionName = this.collectionName;

      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let args = {
            collectionId: this.collection.id,
            collectionName: collectionName,
          };
          await this.renameCollection(args);
          this.loading = false;
          this.dialog = false;
        } catch (err) {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
